type Step = {
  id: number;
  label: string;
};

export const Step1: Step = { id: 0, label: 'Favourite selection' };
export const Step2: Step = { id: 1, label: 'Overview and filter' };
export const Step3: Step = { id: 2, label: 'Best combination' };
